import client from './client';

/** SUPER_ADMIN: process signature blocklist rows. */
export const listProcessSignatures = () => {
  console.log('[admin] listProcessSignatures');
  return client.get('/api/admin/process-signatures');
};

/** SUPER_ADMIN: current minimum agent version (optional endpoint). */
export const getMinAgentVersion = () => {
  console.log('[admin] getMinAgentVersion');
  return client.get('/api/admin/min-version');
};

export const patchMinAgentVersion = (body) => {
  console.log('[admin] patchMinAgentVersion', body);
  return client.patch('/api/admin/min-version', body);
};
